const initialState = {
  fetching: false,
  fetched: false,
  selected: null,
  data: [],
  years: {
    selected: [],
    items: []
  },
  error: null
};

export const categoriesStatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_TASK_TYPES_ITEMS": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        items: [],
        selected: [],
        error: null
      };
    }
    case "FETCH_TASK_TYPES_STATISTICS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_TASK_TYPES_STATISTICS_FULFILLED": {
      let data = action.payload.data.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data
      };
    }
    case "FETCH_TASK_TYPES_STATISTICS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "SET_STATISTICS_TASK_CATEGORY_SELECTED": {
      return {
        ...state,
        selected: action.selected
      };
    }
    case "SET_STATISTICS_YEARS": {
      return {
        ...state,
        years: {
          ...state.years,
          selected: [action.years[action.years.length - 1]],
          items: action.years
        }
      };
    }
    case "SET_STATISTICS_YEARS_SELECTED": {
      return {
        ...state,
        years: {
          ...state.years,
          selected: action.selected
        }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/statistics.js